import type { Effect, Result } from "effect";
import { workerstationService } from "../../effect/service.ts";
import type { BuildIdentityError } from "./model.ts";

export interface BuildIdentityPending<A> {
  readonly promise: Promise<A>;
  readonly settled: Effect.Effect<A, BuildIdentityError>;
}
export interface BuildIdentityAdapters {
  readonly start: <A>(operation: Effect.Effect<A, BuildIdentityError>) => BuildIdentityPending<A>;
  readonly all: <A>(values: readonly Promise<A>[], succeed: (values: A[]) => void, fail: (cause: unknown) => void) => void;
}
export class BuildIdentityMapIo extends workerstationService<BuildIdentityMapIo, {
  readonly accept: <A, B, R>(inputs: readonly A[], use: (value: A) => Effect.Effect<B, BuildIdentityError, R>) => Effect.Effect<{
    readonly accepted: readonly BuildIdentityPending<B>[];
    readonly result: Result.Result<readonly Promise<B>[], BuildIdentityError>;
  }, BuildIdentityError, R>;
  readonly all: <A>(values: readonly Promise<A>[]) => Effect.Effect<A[], BuildIdentityError>;
}>()("shared/BuildIdentityMapIo") {}
